import React from "react";

const SummaryState = ({ previousData }) => {
  if (!previousData) return null;

  const { incident_name, department, scopes, initiation_description } =
    previousData;

  return (
    <div className="py-3">
      {/* Title */}
      <div className="mb-3">
        <h3 className="font-13 font-weight-bold heading-color mb-2">Title</h3>
        <p className="font-13 font-weight-normal text-color">
      
          {incident_name || "-"}
        </p>
      </div>

     

      {/* Scope */}
      <div className="mb-3">
        <h3 className="font-13 font-weight-bold heading-color mb-2">Scope:</h3>
        <p className="font-13 font-weight-normal text-color mb-0">
          {scopes?.map((s) => s.opt_display).join(", ") || "-"}
        </p>
      </div>

      {/* Description */}
      <div className="mb-3">
        <h3 className="font-13 font-weight-bold heading-color mb-2">
          Description:
        </h3>
        <p
          className="font-13 font-weight-normal text-color mb-0"
          dangerouslySetInnerHTML={{
            __html: initiation_description || "<i>No description</i>",
          }}
        />
      </div>
    </div>
  );
};

export default SummaryState;
